class AdvertisementActions {
  constructor() {
    this.generateActions('updateAdsSuccess', 'updateAdsFail', 'updateTargetingKeyValueSuccess', 'updateTargetingKeyValueFail');
  }

  updateAds(showAds){
    return (dispatch, alt) =>
      alt.resolve(async() => {
        try {
          this.updateAdsSuccess(showAds);
        } catch (error) {
          this.updateAdsFail({ error });
        }
      });
  }

  updateAppTargetingKeyValue(key, value) {
    return (dispatch, alt) => {
      alt.resolve(async() => {
        try {
          this.updateTargetingKeyValueSuccess(key, value, 'app');
        } catch (error) {
          this.updateTargetingKeyValueFail(error);
        }
      });
    };
  }

  updateRouteTargetingKeyValue(key, value) {
    return (dispatch, alt) => {
      alt.resolve(async() => {
        try {
          this.updateTargetingKeyValueSuccess(key, value, 'route');
        } catch (error) {
          this.updateTargetingKeyValueFail(error);
        }
      });
    };
  }

  updatePrimaryContentSourceTargetingKeyValue(key, value) {
    return (dispatch, alt) => {
      alt.resolve(async() => {
        try {
          this.updateTargetingKeyValueSuccess(key, value, 'primaryContentSource');
        } catch (error) {
          this.updateTargetingKeyValueFail(error);
        }
      });
    };
  }
}

export default AdvertisementActions;



// WEBPACK FOOTER //
// ./app/flux/actions/Advertisement.js